import { Injectable, Type } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';

import { filter, map, Observable } from 'rxjs';

import {
  ChoiceDialogComponent,
  ChoiceDialogData,
} from '@shared/components/choice-dialog/choice-dialog.component';

export type DialogReturnType = boolean | string | number;

import {
  DialogComponent,
  DialogData,
} from '../components/dialog/dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private defaultDialogConfig: MatDialogConfig = {
    minWidth: '300px',
    maxWidth: '80%',
    minHeight: '400px',
  };

  constructor(private readonly matDialog: MatDialog) {}
  /**
   * Opens a dialog with DialogData
   */
  open(data: DialogData): Observable<boolean> {
    return this.matDialog
      .open(DialogComponent, { data: data })
      .afterClosed()
      .pipe(map((result) => !!result));
  }

  openDialog(component: Type<any>, dialogConfig?: MatDialogConfig) {
    const _config: MatDialogConfig = {
      ...this.defaultDialogConfig,
      ...dialogConfig,
    };

    return this.matDialog.open(component, _config);
  }

  /**
   * Opens a coice dialog with ChoiceDialogData
   */
  openChoice<T extends DialogReturnType>(
    data: ChoiceDialogData<T>
  ): Observable<T | undefined> {
    return this.matDialog
      .open(ChoiceDialogComponent, {
        data: data,
      })
      .afterClosed();
  }

  /**
   * Ask user to confirm discarding unsaved changes
   */
  confirmUnsavedChanges(): Observable<boolean> {
    return this.open({
      type: 'CONFIRM',
      title: 'DIALOG.TITLE.NAVIGATION',
      content: 'DIALOG.MSG.CONFIRM_DISCARD_UNSAVED_CHANGES',
    });
  }

  confirm(title: string, content: string, confirmCallback: () => void): void {
    this.open({
      type: 'CONFIRM',
      title: title,
      content: content,
    })
      .pipe(filter((confirm) => confirm))
      .subscribe((confirm) => {
        confirmCallback();
      });
  }
}
